import React from 'react';
import { StyledBlock, StyledButton } from './GetMoreSection.styles';
import { Heading3 } from '@blueprint/heading';

type HowMuchIsMyHomeWorthProps = {
    isFooterTracking?: boolean;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export const HowMuchIsMyHomeWorthSection = ({
    isFooterTracking = true,
    onClick
}: HowMuchIsMyHomeWorthProps) => {
    const trackingProps = isFooterTracking
        ? {
              'data-track-category': 'footer',
              'data-track-action': 'clickthrough',
              'data-track-label': 'how much is my home worth'
          }
        : {};

    return (
        <StyledBlock color="tone-green-t4">
            <Heading3 size="6">How much is my home worth?</Heading3>
            <StyledButton
                {...trackingProps}
                href="/home-values/"
                onClick={onClick}
            >
                Check price estimate
            </StyledButton>
        </StyledBlock>
    );
};
